import { therapyItems } from '@alberta/konexi-shared';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'therapyColor',
})
export class TherapyColorPipe implements PipeTransform {
  transform(value: any) {
    const retVal = therapyItems.find(therapyItem => therapyItem.id === value);
    if (retVal) {
      return retVal.color;
    }
  }
}
